import { gql } from "@apollo/client";

export const SPRUCE_CONFIG = gql`
  query SpruceConfig {
    spruceConfig {
      banner
      bannerTheme
      containerPools {
        pools {
          id
          distro
          maxContainers
          port
        }
      }
      jira {
        email
        host
      }
      providers {
        aws {
          maxVolumeSizePerUser
        }
      }
      serviceFlags {
        debugSpawnHostDisabled
      }
      slack {
        name
      }
      spawnHost {
        spawnHostsPerUser
        unexpirableHostsPerUser
        unexpirableVolumesPerUser
      }
      ui {
        defaultProject
      }
    }
  }
`;
